import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { constructRestUrl } from '@util/url';

@Injectable()
export class DictionaryRestService {

  constructor(private http: HttpClient) {}

  fetchDictionaries() {
    return this.http.get(constructRestUrl('referenceData'));
  }

}
